<template>
  <div class="app-container role-page">
    <div class="filter-container">
      <div class="filter-title">
        筛选角色
      </div>
      <el-form
        class="filter-form-container"
        label-position="right"
        label-width="150px"
        :inline="true"
      >
        <el-form-item label="角色">
          <el-input
            v-model="listQuery.keyword"
            clearable
            placeholder="请输入角色"
            class="filter-item filter-form-item title-input text-input"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>

        <el-form-item label="端口">
          <el-select
            v-model="listQuery.platform_id"
            clearable
            placeholder="请选择端口"
            class="filter-item filter-form-item status-select"
          >
            <el-option
              v-for="item in platformList"
              :key="item.id"
              :label="item.platform_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="角色状态">
          <el-select
            v-model="listQuery.status"
            clearable
            placeholder="请选择角色状态"
            class="filter-item filter-form-item status-select"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            v-waves
            class="filter-item"
            type="default"
            @click="handleFilter"
          >
            搜索
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            type="default"
            @click="handleFilter($event, true)"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <el-button
        class="filter-item add-btn"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
      >

        <router-link :to="`/account/role/create`">新增后台角色</router-link>
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :span-method="objectSpanMethod"
    >
      <el-table-column align="center" label="端口">
        <template slot-scope="scope">
          <span>{{ scope.row | getRowData(['platform', 'platform_name']) }} </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="角色">
        <template slot-scope="scope">
          <span>{{ scope.row.name }} </span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" width="160">
        <template slot-scope="{row}">
          <span
            :class="row.status ? 'success-text' : 'danger-text'"
          >已{{ row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <el-button
            class="table-btn"
            type="text"
            size="small"
          >
            <router-link :to="`/account/role/edit/${row.id}?isRead=1`">查看</router-link>
          </el-button>
          <template v-if="row.is_edit" class="table-btn-container">
            <el-button
              class="table-btn"
              type="text"
              size="small"
            >
              <router-link :to="`/account/role/edit/${row.id}`">编辑</router-link>
            </el-button>

            <el-popconfirm
              class="table-btn"
              :title="row.status | confirmTitle"
              @onConfirm="updateStatus(row)"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
              >{{ (row.status ? 0 : 1) | statusFilter }}</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :page_size.sync="listQuery.page_size"
      @pagination="getList"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import {
  fetchUserRole,
  updateRole
} from '@/api/role'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { STATUS_MAP } from '@/constances/status'
import { RES_SUCCESS_CODE } from '@/constances/server'
import { fetchPlatformList } from '@/api/common'

const initialQuery = {
  page: 1,
  page_size: 20,
  keyword: undefined,
  status: undefined,
  platform_id: undefined
}

const initialTemp = {
  id: undefined,
  name: ''
}

export default {
  name: 'RoleList',
  components: { Pagination },
  directives: { waves },
  filters: {
    statusFilter(status) {
      return STATUS_MAP[status]
    },
    confirmTitle(status) {
      const text = `确认${STATUS_MAP[status ? 0 : 1]}该角色？`
      return text
    },
    parseRolename(user) {
      const username = _.get(user, ['username'])
      return username || '-'
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('密码必须是8-16位数字和字母（区分大小写）组合'))
      } else {
        if (this.passwordTemp.password_confirmation !== '') {
          this.$refs.passwordPostForm.validateField('password_confirmation')
        }
        callback()
      }
    }

    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordTemp.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ROLES: [],
      list: null,
      total: 0,
      loading: false,
      listLoading: true,
      listQuery: {
        ...initialQuery
      },
      statusOptions: [],
      temp: {
        ...initialTemp
      }, // 表单数据
      rules: {
        name: [
          {
            required: true,
            message: '请输入角色',
            trigger: 'blur',
            transform(value) {
              return value ? value.trim() : ''
            }
          }
        ],
        customer_number: [
          {
            required: true,
            message: '请输入唯一身份关联号',
            trigger: 'blur',
            transform(value) {
              return value ? value.trim() : ''
            }
          }
        ]
      }, // 表单规则
      dialogFormVisible: false,
      dialogStatus: '',
      passwordDialogFormVisible: false,
      passwordTemp: {},
      passwordRules: {
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        password_confirmation: [
          {
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }
        ]
      },
      fileList: [],
      showUpload: false,
      file: `${window.location.origin}/1.xlsx`,
      platformList: []
    }
  },
  watch: {
    /* "temp.role_id"(val) {
      console.log("role_id====", val);
      if (val === 3) {
        this.rules.customer_number[0].required = true;
      } else {
        this.rules.customer_number[0].required = true;
      }
    } */
  },
  created() {
    // 初始化筛状态
    this.statusOptions = Object.keys(STATUS_MAP).map(key => ({
      key,
      label: STATUS_MAP[key]
    }))
    this.getList()
    this.getPlatforms()
  },
  methods: {
    // 获取端口列表
    async getPlatforms() {
      try {
        const res = await fetchPlatformList()
        if (res && res.code === RES_SUCCESS_CODE) {
          this.platformList = res.data.data
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 获取列表
    getList() {
      this.listLoading = true
      fetchUserRole(this.listQuery).then(response => {
        this.list = _.sortBy(response.data.list, (item) => item.platform_id)
        this.total = response.data.total
        this.listLoading = false
      })
    },
    // 列表查询
    handleFilter($event, isClear) {
      this.listQuery.page = 1
      console.log(isClear)
      if (isClear) {
        this.listQuery = {
          ...initialQuery
        }
      }
      this.getList()
    },
    resetTemp() {
      this.temp = _.cloneDeep(initialTemp)
    },
    // 点击新增
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    // 编辑状态
    async updateStatus(row) {
      const index = this.list.findIndex(v => v.id === row.id)

      const payload = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      }
      this.updateReq(payload, index)
    },
    // update请求
    async updateReq(payload, index) {
      this.listLoading = true
      if (payload.name) delete payload.name
      try {
        await updateRole(payload.id, {
          ...payload
        })
        this.listLoading = false
        this.dialogFormVisible = false
        this.passwordDialogFormVisible = false
        this.getList()
        this.$notify({
          title: '操作成功',
          message: '编辑成功',
          type: 'success',
          duration: 2000
        })
      } catch (e) {
        this.listLoading = false
        console.log(e)
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const platforms = this.list.filter(item => item.platform_id === row.platform_id)
        if (platforms.length > 1 && platforms[0].id === row.id) {
          return {
            rowspan: platforms.length,
            colspan: 1
          }
        } else if (platforms.length > 1) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    }
  }
}
</script>

<style lang="css">
.message {
  width: 450px;
  height: auto;
  word-break: break-all;
}
</style>

<style lang="scss" scoped>
@import "~@/styles/form-table.scss";
.filter-container .filter-form-container {
  flex-wrap: wrap;
  .text-input {
    width: 224px;
  }
}
/* .role-page /deep/ .el-form-item__content {
  margin-left: 130px !important;
} */

.form-tips {
  font-size: 12px;
  color: #999;
  padding-left: 180px;
}

.upload-body {
  width: 600px;
  margin: 0 auto;
}

.leading-action {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 25px;
}

.leading-action .down-file {
  color: #409eff;
  margin-left: 10px;
}

.leading-button {
  margin-top: 25px;
}
</style>
